import { useComputed } from "@preact/signals-react"
import { OverlayTrigger, Tooltip } from "react-bootstrap"
import Icon from "./Icon"

export default function PageTitle({title, canEditSignal}) {

    const permissionLevelTooltip = useComputed(() => {
        return canEditSignal.value ?
            'You have edit access on this page.' :
            'You have read only access on this page.'
    })
    const permissionLevelIcon = useComputed(() => {
        return canEditSignal.value ?
            'unlock' :
            'lock'
    })

    return (
        <h1 className="display-1 fs-2 px-3 my-3">{title}
            <OverlayTrigger placement="right" delay={{ show: 250, hide: 400 }} overlay={(<Tooltip id="page-permission-tooltip">{permissionLevelTooltip.value}</Tooltip>)}>
                <span className="mx-2">
                    <Icon icon={permissionLevelIcon.value} width="16" height="16" />
                </span>
            </OverlayTrigger>
        </h1>
    )
}